<template>
  <div class="article-edit">
    <ArticleForm :is-edit-mode="true" />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import ArticleForm from '@/components/Company/ArticleForm';

export default {
  name: 'ArticleEdit',
  metaInfo() {
    return {
      title: this.$t('edit'),
    };
  },
  components: {
    ArticleForm,
  },
  setup() {
    return {
      canSeeBlog: ref(process.env.VUE_APP_DEV_TOOLS === 'true'),
    };
  },
};
</script>

<style lang="scss" scoped>
.article-edit {
  background: #F3F3F3;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
</style>

<i18n locale="en" lang="yaml">
edit: Edit article
</i18n>

<i18n locale="ru" lang="yaml">
edit: Редактирование статьи
</i18n>
